module.exports = __webpack_public_path__ + "img/66-78-preview.4cd35ad0.jpg";